import { combineReducers } from "redux";
import resource from "@/redux/slices/resources/ResourceSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import orgSlice from "@/redux/slices/organizations/OrganizationSlice";
import settingSlice from "@/redux/slices/settings/SettingSlice";
import notificationSlice from "@/redux/slices/notification/NotificationSlice";
import LoadingSlice from "./slices/loading/LoadingSlice";

const rootReducer = (asyncReducers?: any) => (state: any, action: PayloadAction) => {
  const combinedReducer = combineReducers({
    orgInfo: orgSlice,
    resources: resource,
    settingInfo: settingSlice,
    notificationInfo: notificationSlice,
    loading: LoadingSlice,
    ...asyncReducers,
  });

  return combinedReducer(state, action);
};

export default rootReducer;
